import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './FetchBaseQuery';


export const graphApi = createApi({
  reducerPath: 'graphApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Dashboard'],
  endpoints: (builder) => ({
    // Existing endpoint
    getContractDashboard: builder.query({
      query: ({ from = 2023, to = 2025, yearInput = 2024 }) => 
        `contract/dashboard?type=range&from=${from}&to=${to}&yearInput=${yearInput}`,
      transformResponse: (res) => res.response, // return both dataWon & dataLost
    }),
  }),
});

export const {
  useGetContractDashboardQuery,
} = graphApi;
